import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiLicenseDashboardModule } from '@components/shared/license/ui-license-dashboard.module';
import { UiSettingFormModule } from '@components/ui-forms/ui-setting-form.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid';
import { DeactivateOfflineModalComponent } from '@pages/license/modals/deactivate-offline';
import { ExpiredModalComponent } from '@pages/license/modals/expired/expired.modal';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiClipboardModule } from '@uipath/angular/directives/ui-clipboard';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiDragAndDropModule } from '@uipath/angular/directives/ui-drag-and-drop-file';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import {
    NamedLicenseComponent,
    RuntimeLicenseComponent,
} from './grids';
import { LicensePageComponent } from './license.page';
import {
    ActivateOfflineModalComponent,
    ActivateOnlineModalComponent,
    RuntimeEditModalComponent,
    UpdateModalComponent,
} from './modals';

const MODALS = [
    ActivateOnlineModalComponent,
    ActivateOfflineModalComponent,
    UpdateModalComponent,
    RuntimeEditModalComponent,
    DeactivateOfflineModalComponent,
    ExpiredModalComponent,
];

const PAGES = [
    LicensePageComponent,
    RuntimeLicenseComponent,
    NamedLicenseComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        UiClipboardModule,
        UiDragAndDropModule,
        UiSettingFormModule,
        UiLicenseDashboardModule,
        UiGridModule,
        UiGridResetModule,
        UiNgLetModule,
        UiDateFormatModule,
        UiSpinnerButtonModule,
    ],
    declarations: [
        ...PAGES,
        ...MODALS,
    ],
    exports: [
        ...PAGES,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class LicenseModule { }
